<template>
  <div class="has-tooltip inline-block">
    <span
      class="tooltip rounded-xl shadow-lg p-2 bg-white border-primary-300 border text-gray-800 -mt-11"
      ref="tooltip"
      ><slot name="tooltip"></slot
    ></span>
    <p ref="text"><slot name="text"></slot></p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$refs.tooltip.style.marginLeft =
      (this.$refs.text.clientWidth - this.$refs.tooltip.clientWidth) / 2 + "px";
  },
};
</script>

<style>
.tooltip {
  visibility: hidden;
  position: absolute;
}

.has-tooltip:hover .tooltip {
  visibility: visible;
  z-index: 50;
}

.tooltip::after {
  content: " ";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(73, 34, 128, 0.3) transparent transparent transparent;
}
</style>